import { render } from "./print-plain-tetap.vue?vue&type=template&id=28876c13&scoped=true"
import script from "./print-plain-tetap.vue?vue&type=script&lang=js"
export * from "./print-plain-tetap.vue?vue&type=script&lang=js"

import "./print-plain-tetap.vue?vue&type=style&index=0&id=28876c13&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28876c13"]])

export default __exports__